import React, { useState } from "react";
import { PaginaInfo } from "@/Models/Utils/Pagina/Pagina";
import { useListarTodasInscricoes, listarTodasInscricoes } from "@/Services/Domain/Viagem/ViagemService";
import ComponentePermissao from "@/Components/Base/Permissao/ComponentePermissao";
import { TodasInscricoesTableBasic } from "./TodasInscricoesTableBasic";
import { Button, Col, Form, Grid, Row } from "antd";
import ViagemSelect from "../../ViagemSelect";
import dayjs, { Dayjs } from "dayjs";
import InputRangePicker from "@/Components/Base/Input/InputRangePicker";
import Utilitario from "@/Utils/Utilitario";

type Filtro = Parameters<typeof useListarTodasInscricoes>[1];
type FormType = { somenteViagens: Filtro["somenteViagens"], intervalo:[Dayjs,Dayjs] };

export const TodasInscricoesScreen: React.FC = () => {

    const breakpoint = Grid.useBreakpoint();
    const initIntervalo = [dayjs().startOf('year'), dayjs().endOf('year')];

    const [filtro, setFiltro] = useState<Filtro>({
        pagina: new PaginaInfo(1, 15),
        intervalo: initIntervalo
    });

    const { data: queryData, ...query } = useListarTodasInscricoes({ enabled: true }, filtro);

    return (
        <ComponentePermissao tipo="any" permissoes={["ListarInscricoesDaViagem", "DomainViagemRelatorioListarInscricoesRecentes"]}>
            <Form<FormType>
                layout="vertical"
                initialValues={{
                    intervalo: initIntervalo
                }}
                onFinish={(v) => {
                    setFiltro((prev) => ({ ...prev, somenteViagens: v.somenteViagens, intervalo : v.intervalo }));
                }}
            >
                <Row gutter={[8, 8]}>
                    <Col xs={24} sm={12} md={13} lg={14} xl={16} xxl={18}>
                        <Form.Item<FormType> name={"somenteViagens"} label={"Viagens"}>
                            <ViagemSelect mode="multiple" />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                        <Form.Item<FormType> 
                            name={"intervalo"} 
                            label="Intervalo" 
                            rules={[
                            ]}
                        >
                            <InputRangePicker 
                                disabledDate={(dia, v) => {
                                    if (v.from) {
                                        if (dia < v.from) return true;
                                        if (dia > v.from.add(1, "year")) return true;
                                    }
                                    return false;
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={3} lg={2} xl={2} xxl={2}>
                        <Form.Item label={breakpoint.md ? <></> : undefined}>
                            <Button style={{ width: "100%" }} type="primary" htmlType="submit">
                                Listar
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>

            <TodasInscricoesTableBasic
                tableProps={{
                    dataSource: queryData?.data,
                    loading: query.isFetching,
                    onChange(pagination, filters, sorter, extra) {
                        setFiltro((prev) => ({
                            ...prev,
                            pagina: new PaginaInfo(pagination.current, pagination.pageSize),
                        }));
                    },
                    csv : {
                        enabled: true,
                        filename: "Inscricoes.csv",
                        acquireSource: async () => {
                            const response = await listarTodasInscricoes({ filtros : filtro });
                            return response?.data ?? [];
                        }
                    }
                }}
            />
        </ComponentePermissao>
    );
}
